var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestionRed = function SvgQuestionRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "#D73A49",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 24C37 30.9036 31.4036 36.5 24.5 36.5C17.5964 36.5 12 30.9036 12 24C12 17.0964 17.5964 11.5 24.5 11.5C31.4036 11.5 37 17.0964 37 24ZM24.5 17.4028C22.4928 17.4028 20.6806 18.8798 20.6806 20.9403C20.6806 21.5156 21.1469 21.9819 21.7222 21.9819C22.2975 21.9819 22.7639 21.5156 22.7639 20.9403C22.7639 20.2344 23.4282 19.4861 24.5 19.4861C25.5718 19.4861 26.2361 20.2344 26.2361 20.9403C26.2361 21.3321 26.0192 21.6031 25.3608 22.0069L25.3565 22.0097C24.6372 22.456 23.4583 23.2682 23.4583 24.8946V25.2103C23.4583 25.7856 23.9247 26.2519 24.5 26.2519C25.0753 26.2519 25.5417 25.7856 25.5417 25.2103V24.8946C25.5417 24.4765 25.7681 24.2062 26.4528 23.7812C27.1669 23.3429 28.3194 22.5314 28.3194 20.9403C28.3194 18.8798 26.5072 17.4028 24.5 17.4028ZM24.4924 27.7621C23.9169 27.7621 23.4507 28.2285 23.4507 28.8037C23.4507 29.3792 23.9169 29.8454 24.4924 29.8454H24.5074C25.0826 29.8454 25.549 29.3792 25.549 28.8037C25.549 28.2285 25.0826 27.7621 24.5074 27.7621H24.4924Z"
  })));
};
export default SvgQuestionRed;